<form [formGroup]="signUpForm" class="signup-form" (ngSubmit)="onSubmit()">
    <app-email-verification [parentComponent]="componentName"
        (verifiedOTP)="onVerifyOTP($event)"></app-email-verification>
    @if(signUpForm.value.email !== '') {
    <div>
        <div class="form-floating mt-4 mandatory-select">
            <ng-select [notFoundText]="'HEADER.NO_ITEMS_FOUND' | translate" [searchable]="false"
                [dropdownPosition]="'bottom'" [clearable]="false" formControlName="preferredLanguage"
                [placeholder]="'PROFILE.PREFERRED_LANGUAGE' | translate">
                @for (language of preferredLanguageList; track $index) {
                <ng-option [value]="language.value">
                    {{language.name | translate}}
                </ng-option>
                }
            </ng-select>
            <app-validation-message [control]="signUpForm.get('preferredLanguage')"
                [formSubmission]="isSubmitted"></app-validation-message>
        </div>
        <div>
            <div class="form-floating mt-4 position-relative">
                <input class="form-control px-4 password"
                    [ngClass]="showPassword ? 'form-control password-input ' : 'form-control password-input pw'"
                    type="text" autocomplete="off" [placeholder]="'SIGN_IN.PASSWORD' | translate"
                    formControlName="password" />
                <label class="mandatory">{{'SIGN_IN.PASSWORD' | translate}}</label>

                @if (!showPassword) {
                <span class="password-eye-icon" (click)="showPassword = !showPassword">

                    <img class="" src="assets/icons/view-stroke-rounded.svg" />
                </span>
                }
                @else {
                <span class="password-eye-icon" (click)="showPassword = !showPassword">

                    <img class="" src="assets/icons/view-off-slash-stroke-rounded.svg" />
                </span>
                }
                <app-validation-message [control]="signUpForm.get('password')" [formSubmission]="isSubmitted"
                    [customErrorMessages]="passwordCustomValidation"></app-validation-message>
            </div>
        </div>
        <div>
            <div class="form-floating mt-4 position-relative">
                <input class="form-control px-4 password "
                    [ngClass]="showConfrimPassword ? 'form-control password-input ' : 'form-control password-input pw'"
                    type="text" [placeholder]="'FORGOT.CONFIRM_PASSWORD' | translate" formControlName="confirmPassword"
                    [appConfirmPassword]="this.signUpForm.get('password')" />
                <label class="mandatory">{{'FORGOT.CONFIRM_PASSWORD' | translate}}</label>

                @if (!showConfrimPassword) {
                <span class="password-eye-icon" (click)="showConfrimPassword = !showConfrimPassword">

                    <img class="" src="assets/icons/view-stroke-rounded.svg" />
                </span>
                } @else {
                <span class="password-eye-icon" (click)="showConfrimPassword = !showConfrimPassword">

                    <img class="" src="assets/icons/view-off-slash-stroke-rounded.svg" />
                </span>
                }
                <app-validation-message [control]="signUpForm.get('confirmPassword')"
                    [formSubmission]="isSubmitted"></app-validation-message>
            </div>
        </div>
        <div class="form-element mt-4">
            <div class="d-flex align-items-center">
                <input class="form-check-input flex-shrink-0 mx-2 mb-1" id="termsService" type="checkbox"
                    (change)="termsAndConditionChange()" formControlName="termsAndCondition" />
                <p class="click-here text-2">
                    {{'SIGN_UP.I_ACCEPT' | translate}}

                    <span class="c-pointer" (click)="openModal(componentsName.TERMS_AND_CONDITIONS)">{{'SIGN_UP.TERMS' |
                        translate}}</span>
                    {{'SIGN_UP.AND' | translate}}
                    <span class="c-pointer"
                        (click)="openModal(componentsName.PRIVACY_POLICY)">{{'SIGN_UP.PRIVACY_POLICY' |
                        translate}}</span>
                </p>
            </div>
            <app-validation-message [control]="signUpForm.get('termsAndCondition')"
                [formSubmission]="isSubmitted"></app-validation-message>
        </div>
    </div>
    <button [disabled]="!signUpForm.valid" class="btn-1 w-100 p-2 my-4"> {{'SIGN_UP.SIGN_UP_BUTTON' |
        translate}}
    </button>
    }
</form>